import styled from 'styled-components'
import { Type } from '../../../../../types/Survey/Element'
import { Type as AnswerType } from '../../../../../types/Survey/Answer/Element'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import Dropdown from '../../../../UI/Dropdown/Dropdown'
import checkForAvailability from '../../Configuration/ElementList/Element/helper/checkForAvailability'
import { Survey } from '../../../../../types/Survey/Survey'
import DynamicNumberDescriptionAmountInput from './AnswerElement/DynamicNumberDescriptionAmountInput'
import { sortUnits } from '../../../../../utility'
import { Answer } from '../../../../../types/Survey/Answer/Answer'
import { useEffect, useState } from 'react'
import AmountToggleInput from './AnswerElement/AmountToggleInput'
import DynamicText from './AnswerElement/DynamicText'
import NumberInput from './AnswerElement/NumberInput'
import OrganizationUnitCooperationSelection from './AnswerElement/OrganizationUnitCooperationSelection'

const Wrapper = styled.div`
  /* width: calc(100% / 2 - (15px * 1 / 2));
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) { */
  width: 100%;
  /* } */
`

type Props = {
  survey: Survey
  allAnswers: Answer[]
}

const ManagerElementList: React.FC<Props> = ({ survey, allAnswers }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [orgaUnitUUID, setOrgaUnitUUID] = useState(null)
  const [answer, setAnswer] = useState<Answer>(null)

  useEffect(() => {
    if (!orgaUnitUUID && Array.isArray(survey.context?.organizationUnitList)) {
      const unitUUID = survey.context.organizationUnitList[0].uuid
      setOrgaUnitUUID(unitUUID)
      const answer = allAnswers.find((answer) => answer.organizationUnitUUID === unitUUID)
      setAnswer(!!answer ? answer : null)
    }
  }, [survey, orgaUnitUUID, allAnswers])

  const selectOrgaUnit = (orgaUnitUUID: string) => {
    setOrgaUnitUUID(orgaUnitUUID)
    const answer = allAnswers.find((answer) => answer.organizationUnitUUID === orgaUnitUUID)
    setAnswer(!!answer ? answer : null)
  }

  const getAnswerElement = <T,>(elementUUID: string): T => {
    return answer?.elements.find((element) => element.uuid === elementUUID) as T
  }

  if (!survey) return <></>
  return (
    <div>
      <div className="pb-10">
        <div className="flex flex-row gap-3">
          {checkForAvailability(survey, Type.ORGANIZATION_UNIT_SELECTION) && (
            <Dropdown
              label={t.survey.analysis.averageValues.filter.selectOrganizationUnit}
              items={survey.context.organizationUnitList.sort(sortUnits).map((unit) => ({ label: unit.name, value: unit.uuid }))}
              value={orgaUnitUUID}
              onChange={selectOrgaUnit}
            />
          )}
        </div>
      </div>
      {!answer && <div className="text-center text-gray text-sm">{t.survey.analysis.averageValues.noDataAvailable}</div>}
      {!!answer && (
        <>
          <div className="flex flex-col flex-wrap gap-[15px]">
            {survey.elements.map(
              (element) =>
                // check if element type is in Answer-Type enum
                !!AnswerType[element.type] && (
                  <Wrapper className="shadow-lg bg-white p-3" key={element.uuid}>
                    {element.type === Type.DYNAMIC_NUMBER_DESCRIPTION_AMOUNT_INPUT && (
                      <DynamicNumberDescriptionAmountInput element={element} answerElement={getAnswerElement(element.uuid)} />
                    )}
                    {element.type === Type.AMOUNT_TOGGLE_INPUT && (
                      <AmountToggleInput element={element} answerElement={getAnswerElement(element.uuid)} />
                    )}
                    {element.type === Type.DYNAMIC_TEXT && <DynamicText element={element} answerElement={getAnswerElement(element.uuid)} />}
                    {element.type === Type.NUMBER_INPUT && <NumberInput element={element} answerElement={getAnswerElement(element.uuid)} />}
                    {element.type === Type.ORGANIZATION_UNIT_COOPERATION_SELECTION && (
                      <OrganizationUnitCooperationSelection survey={survey} element={element} answerElement={getAnswerElement(element.uuid)} />
                    )}
                  </Wrapper>
                ),
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default ManagerElementList
